import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="zone-inventory"
export default class extends Controller {
  static targets = ["select", "display", "loading", "error"]
  static values = {
    unit: String
  }

  connect() {
    // Update inventory when zone is already selected on page load
    if (this.selectTarget.value) {
      this.updateInventory()
    }
  }

  updateInventory() {
    const zoneId = this.selectTarget.value

    // Keep fixed display area visible, only toggle inner messages.
    if (this.errorTarget) this.errorTarget.classList.add("hidden")
    if (this.loadingTarget) this.loadingTarget.classList.remove("hidden")
    const totalElement = this.displayTarget?.querySelector("[data-inventory-total]")
    if (totalElement) totalElement.textContent = ""

    if (!zoneId || zoneId === "") {
      // No zone selected: keep reserved area with placeholders.
      if (this.loadingTarget) this.loadingTarget.classList.add("hidden")
      if (totalElement) totalElement.textContent = "—"
      return
    }

    // Get CSRF token from meta tag
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    
    // Fetch inventory from API
    fetch(`/movements/zone_inventory.json?zone_id=${zoneId}`, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken || ""
      },
      credentials: "same-origin"
    })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => {
            throw new Error(`HTTP error! status: ${response.status}, body: ${text}`)
          })
        }
        return response.json()
      })
      .then(data => {
        // Hide loading/error and populate fixed display area
        if (this.loadingTarget) this.loadingTarget.classList.add("hidden")
        if (this.errorTarget) this.errorTarget.classList.add("hidden")

        // Update display with inventory data
        if (totalElement) {
          const total = typeof data.total === 'number' ? data.total : parseFloat(data.total)
          totalElement.textContent = `${total.toFixed(2)} ${this.unitValue}`.trim()
        }
      })
      .catch(error => {
        console.error("Error fetching zone inventory:", error)
        // Keep fixed area visible, show error message and placeholders.
        if (this.loadingTarget) this.loadingTarget.classList.add("hidden")
        if (this.errorTarget) this.errorTarget.classList.remove("hidden")
        const totalElement = this.displayTarget?.querySelector("[data-inventory-total]")
        if (totalElement) totalElement.textContent = "—"
      })
  }
}
